<template lang="pug">
  .flex-1
    h4.p-5 Настройки - Стадии
    //- pre {{ JSON.stringify(stage_lists, undefined, 2) }}
    .d-flex.flex-column.flex-grow.px-5
      .row
        div(v-if="isAdmin === 'no'" :class="{'col-md-7': isHelp, 'col-md-11': !isHelp}")
          div(class="mt-2 alert alert-danger" role="alert") У вас недостаточно прав, нужны права администратора портала!
        div(v-if="isAdmin === 'yes'" :class="{'col-md-7': isHelp, 'col-md-11': !isHelp}")
          .form-group
            label(for="select_track") Выкл/вкл автоматическую смену стадий:
            div
              label.switch
                input(type="checkbox" v-model="isCheckStages")
                span.slider.round
          
          // Переключатель - одна/несколько воронок
          //- .form-group(v-if="isCheckStages")
          //-   label(for="select_track") Одна воронка/Несколько воронок:
          //-   div
          //-     label.switch
          //-       input(type="checkbox" v-model="funnel_mode")
          //-       span.slider.round
          
          .loading(v-if="isLoading && isCheckStages") Загрузка...

          .form-group(style="overflow-x: auto;" v-if="!isLoading && isCheckStages")

            div(v-if="isV1" class="alert alert-warning" role="alert") Настройте воронки!

            // для одной воронки
            //- table.table.table-striped(v-if="tracker_version === 'v1'")
            //-   thead
            //-     tr
            //-       //- th(style="white-space: nowrap;") Воронка
            //-       //- th Активна
            //-       th(style="white-space: nowrap;" v-for="(el, i) in statuses.filter(e => e.visible)" :key="'th_'+i") {{ el.name }}
            //-   tbody
            //-     tr(v-for="(funnel, i) in stage_lists" :key="'tr_'+i")
            //-       //- td {{ funnel.name }}
            //-       //- td
            //-       //-   label.switch
            //-       //-     input(type="checkbox" @change="onSelectStage({ funnel: i })" v-model="stage_lists[i]['active']")
            //-       //-     span.slider.round
            //-       td(style="flex: 1;" v-for="(el, k) in statuses.filter(e => e.visible)" :key="'td_'+k")
            //-         select.form-control(style="width: 100%;" @change="onSelectStage({ funnel: i })" v-model="stage_lists[i][el.field_name]")
            //-           option(v-for="(stage, j) in stage_lists[i].stages" :key="j" :value="stage.STATUS_ID") {{ stage.NAME }} [{{ stage.STATUS_ID }}]
            
            table.table.table-striped
              thead
                tr
                  th(style="white-space: nowrap;") Воронка
                  th Активна
                  th(style="white-space: nowrap;" v-for="(el, i) in statuses.filter(e => e.visible)" :key="'th_'+i") {{ el.name }}
              tbody
                tr(v-for="(funnel, i) in stage_lists" :key="'tr_'+i")
                  td {{ funnel.name }}
                  td
                    label.switch
                      input(type="checkbox" @change="onSelectStage({ funnel: i })" v-model="stage_lists[i]['active']")
                      span.slider.round
                  td(style="flex: 1;" v-for="(el, k) in statuses.filter(e => e.visible)" :key="'td_'+k")
                    select.form-control(style="width: 100%;" @change="onSelectStage({ funnel: i })" v-model="stage_lists[i][el.field_name]")
                      option(v-for="(stage, j) in stage_lists[i].stages" :key="j" :value="stage.STATUS_ID") {{ stage.NAME }} [{{ stage.STATUS_ID }}]

          .form-group
            label(for="select_noti") Выкл/вкл уведомления об ошибках сканирования:
            div
              label.switch
                input(type="checkbox" v-model="isNotify")
                span.slider.round
                
          .form-group.mb-5
            label(for="recipient") Пользователь, которому будут отправляться уведомления:
              select(class="form-control" style="width: auto;" v-model="recipient_id")
                option(v-for="(el, i) in recipients" :key="i" :value="el.ID") {{ el.NAME }} {{el.LAST_NAME}} [{{ el.EMAIL }}]
          
          button(type="button" class="btn btn-primary" @click="save") Сохранить
          div(v-for="(el, i) in alert_s" v-bind:key="i" class="mt-2 alert" v-bind:class="{'alert-success': el.type === 'success', 'alert-danger': el.type === 'error', 'alert-warning': el.type === 'warning'}" role="alert") {{el.name}}: {{ el.status }}

        div(class="d-flex flex-column flex-grow" v-bind:class="{'col-md-5': isHelp, 'col-md-1': !isHelp}")
          .row.d-flex.flex-row.justify-content-end
            i(@click="isHelp = !isHelp" class="fas fa-question help-icon")
          .row.sp-c(v-if="isHelp")
            p Автоматическая смена стадий позволяет автоматизировать воронку доставки. Когда меняется статус посылки - сделка продвигается по воронке.
            p 
              | Статусы посылки:<br>
              ul
                li(v-for="{ helpInfo } in statuses.filter(e => e.visible)") {{ helpInfo }} 
            p Уведомления приходят администратору об ошибках в сканировании.
</template>

<script>
import axios from 'axios'
import Bitrix24 from '@/lib/Bitrix24'
import common from '@/lib/common'
import urls from '@/lib/urls'

export default {
  data() {
    return {
      isHelp: false,
      statuses: [
        {
          name: '200 - доставлено',
          field_name: 'delivered',
          helpInfo: '(200 - доставлено) - клиент забрал посылку из пункта выдачи заказов (ПВЗ)',
          visible: true
        },
        {
          name: '300 - в пути',
          field_name: 'onMyWay',
          helpInfo: '(300 - в пути) - посылка отправлена, но еще не прибыла в ПВЗ',
          visible: true
        },
        {
          name: '400 - не удалось',
          field_name: 'failed',
          helpInfo: '(400 - не удалось) - клиент отказался от посылки, не доставлена, потеряна и т.д.',
          visible: true
        },
        {
          name: '500 - ожидает',
          field_name: 'awaiting',
          helpInfo: '(500 - ожидает) - посылка находится в ПВЗ',
          visible: true
        },
        {
          name: '600 - возврат',
          field_name: 'return',
          helpInfo: '(600 - возврат) - ',
          visible: false
        }
      ],
      recipients: [],
      recipient_id: null,
      isNotify: false,
      isCheckStages: false,
      stage_lists: [],
      stages_structure: [],
      alert_s: [],
      stages_settings: null,
      tracker_version: 'loading',
      isV1: false,
      allStages: [],
      funnel_mode: false,
      isLoading: true,
      isAdmin: 'loading',
    }
  },

  created() {
    const self = this

    this.getSettingsStages()
    this.getSettingsAlerts()

    Bitrix24.callMethod('user.get', { FILTER: { "ACTIVE": true } }).then(response => {
      self.recipients = response.data()
    }).catch(error => {
      console.log(error)
    })
  },

  methods: {
    async getSettingsStages(){
      const self = this

      axios.get(urls.getStages, await common.setAuthorizationHeader()).then(response => {
        self.stages_settings = response.data
        self.isCheckStages = self.stages_settings.enabled

        let searchTrackerVersion
        if(Array.isArray(response.data.stages)){
          searchTrackerVersion = response.data.stages.find(e => e.category_id === 'all' && e.enabled)
        } else{
          searchTrackerVersion = true
        }
        if(searchTrackerVersion){
          self.isV1 = true
        }
        self.tracker_version = 'v2'
        self.funnel_mode = true

        self.getStages(response.data)
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            self.stages_settings = response.data
            self.isCheckStages = self.stages_settings.enabled

            let searchTrackerVersion
            if(Array.isArray(response.data.stages)){
              searchTrackerVersion = response.data.stages.find(e => e.category_id === 'all' && e.enabled)
            } else{
              searchTrackerVersion = true
            }
            if(searchTrackerVersion){
              self.isV1 = true
            }
            self.tracker_version = 'v2'
            self.funnel_mode = true

            self.getStages(response.data)
          }).catch(err => {
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          console.log(error)
        } else{
          console.log(error)
        }
      })
    },

    async getSettingsAlerts(){
      const self = this

      axios.get(urls.getAlerts, await common.setAuthorizationHeader()).then(response => {
        self.recipient_id = response.data.recipient_id
        self.isNotify = response.data.enabled
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            self.recipient_id = response.data.recipient_id
            self.isNotify = response.data.enabled
          }).catch(err => {
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          console.log(error)
        } else{
          console.log(error)
        }
      })
    },

    async getStages(stages_settings){
      const self = this
      Bitrix24.callMethod('crm.dealcategory.default.get', {}).then(response => {
        if(response.error()){
          console.log(response.error())
        } else{
          let nullStageList = response.data()

          Bitrix24.callMethod(
            'crm.dealcategory.list', 
            { 
              order: { "SORT": "ASC" },
              filter: { "!NAME": "" },
              select: [ "ID", "NAME", "SORT" ]
            }
          ).then(async (response) => {
            if(response.status === 400 || response.status === 403){
              self.isAdmin = 'no'
            } else{
              self.isAdmin = 'yes'
              let allStageLists = []
              allStageLists.push(nullStageList)
              allStageLists = allStageLists.concat(response.data())

              let s = allStageLists.length
              self.stage_lists = []
              let listStagePromises = []

              for(let i = 0; i < s; i++){
                listStagePromises.push(Bitrix24.callMethod('crm.dealcategory.stage.list', { id: allStageLists[i].ID }))
              }

              if(self.tracker_version === 'v1'){
                (await Promise.all(listStagePromises)).map((e, i) => { 
                  self.allStages = self.allStages.concat(e.answer.result)
                })

                let obj = {}

                let funnel

                if(Array.isArray(self.stages_settings.stages)){
                  funnel = self.stages_settings.stages.find(e => e.category_id === 'all' && e.enabled)
                } else[
                  funnel = false
                ]

                if(funnel){
                  obj = {
                    id: funnel.category_id,
                    name: 'single_funnel',
                    "stages": self.allStages,
                    "delivered": funnel["200"],
                    "onMyWay": funnel["300"],
                    "failed": funnel["400"],
                    "awaiting": funnel["500"],
                    "return": funnel["600"],
                    "active": funnel["enabled"]
                  }
                } else{
                  obj = {
                    id: 'all',
                    name: 'single_funnel',
                    "stages": self.allStages,
                    "delivered": '',
                    "onMyWay": '',
                    "failed": '',
                    "awaiting": '',
                    "return": '',
                    "active": true
                  }
                }

                self.stage_lists.push(obj)
                self.isLoading = false
              } else if(self.tracker_version === 'v2'){
                let listStageResponse = (await Promise.all(listStagePromises)).map((e, i) => {
                  let stagesInSettings = self.stages_settings.stages.find(a => a.category_id === (allStageLists[i].ID).toString())

                  let obj = {}

                  if(stagesInSettings){
                    obj = {
                      id: allStageLists[i].ID,
                      name: allStageLists[i].NAME,
                      "stages": e.answer.result,
                      "delivered": stagesInSettings["200"],
                      "onMyWay": stagesInSettings["300"],
                      "failed": stagesInSettings["400"],
                      "awaiting": stagesInSettings["500"],
                      "return": stagesInSettings["600"],
                      "active": stagesInSettings["enabled"]
                    }
                  } else{
                    obj = {
                      id: allStageLists[i].ID,
                      name: allStageLists[i].NAME,
                      "stages": e.answer.result,
                      "delivered": "",
                      "onMyWay": "",
                      "failed": "",
                      "awaiting": "",
                      "return": "",
                      "active": false
                    }
                  }

                  return obj 
                })

                self.stage_lists = listStageResponse.sort((a, b) => { parseInt(a.id) - parseInt(b.id) })
                self.isLoading = false
              }
            }
          }).catch(error => {
            console.log(error)
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },

    onSelectStage(funnel){
      if(funnel.funnel !== null){
        if(this.stage_lists[funnel.funnel]["active"]){
          this.stage_lists[funnel.funnel]["delivered"] === '' ? this.stage_lists[funnel.funnel]["delivered"] = this.stage_lists[funnel.funnel].stages[0].STATUS_ID : false
          this.stage_lists[funnel.funnel]["onMyWay"] === '' ? this.stage_lists[funnel.funnel]["onMyWay"] = this.stage_lists[funnel.funnel].stages[0].STATUS_ID : false
          this.stage_lists[funnel.funnel]["failed"] === '' ? this.stage_lists[funnel.funnel]["failed"] = this.stage_lists[funnel.funnel].stages[0].STATUS_ID : false
          this.stage_lists[funnel.funnel]["awaiting"] === '' ? this.stage_lists[funnel.funnel]["awaiting"] = this.stage_lists[funnel.funnel].stages[0].STATUS_ID : false
          this.stage_lists[funnel.funnel]["return"] === '' ? this.stage_lists[funnel.funnel]["return"] = this.stage_lists[funnel.funnel].stages[0].STATUS_ID : false
        }
        this.stages_structure = JSON.parse(JSON.stringify(this.stage_lists))
        this.stages_structure = this.stages_structure.map(e => {
          let obj = {
            category_id: (e.id).toString(),
            enabled: e.active,
            "200": e["delivered"],
            "300": e["onMyWay"],
            "400": e["failed"],
            "500": e["awaiting"],
            "600": e["return"]
          }
          return obj
        })
      } else{
        this.stages_structure = JSON.parse(JSON.stringify(this.stage_lists))
        this.stages_structure = this.stages_structure.map(e => {
          let obj = {
            category_id: (e.id).toString(),
            enabled: e.active,
            "200": e["delivered"],
            "300": e["onMyWay"],
            "400": e["failed"],
            "500": e["awaiting"],
            "600": e["return"]
          }
          return obj
        })
      }
    },

    save(){
      this.saveStages()
      this.saveAlerts()
    },
    async saveAlerts(){
      const self = this
      this.alert_s = []

      let postData = {
        recipient_id: parseInt(this.recipient_id),
        enabled: this.isNotify
      }

      axios.post(urls.saveAlerts, postData, await common.setAuthorizationHeader()).then(response => {
        if(response.status === 200){
          let el = {
            id: 0,
            name: 'Уведомления',
            type: 'success',
            status: response.data
          }
          this.alert_s.push(el)
        }
        this.getSettingsAlerts()
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            let el = {
              id: 0,
              name: 'Уведомления',
              type: 'success',
              status: response.data
            }
            self.alert_s.push(el)
            self.getSettingsAlerts()
          }).catch(err => {
            let el = {
              id: 0,
              name: 'Уведомления',
              type: 'error',
              status: error
            }
            self.alert_s.push(el)
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          let el = {
            id: 0,
            name: 'Уведомления',
            type: 'error',
            status: error
          }
          self.alert_s.push(el)
          console.log(error)
        } else{
          let el = {
            id: 0,
            name: 'Уведомления',
            type: 'error',
            status: error
          }
          self.alert_s.push(el)
          console.log(error)
        }
      })
    },
    async saveStages(){
      const self = this

      let postData = {
        enabled: this.isCheckStages,
        stages: this.stages_structure
      }

      axios.post(urls.saveStages, postData, await common.setAuthorizationHeader()).then(response => {
        if(response.status === 200){
          let el = {
            id: 0,
            name: 'Стадии',
            type: 'success',
            status: response.data
          }
          this.alert_s.push(el)
        }
        this.getSettingsStages()
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            let el = {
              id: 0,
              name: 'Стадии',
              type: 'success',
              status: response.data
            }
            self.alert_s.push(el)
            self.getSettingsStages()
          }).catch(err => {
            let el = {
              id: 0,
              name: 'Стадии',
              type: 'error',
              status: error
            }
            self.alert_s.push(el)
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          let el = {
            id: 0,
            name: 'Стадии',
            type: 'error',
            status: error
          }
          self.alert_s.push(el)
          console.log(error)
        } else{
          let el = {
            id: 0,
            name: 'Стадии',
            type: 'error',
            status: error
          }
          self.alert_s.push(el)
          console.log(error)
        }
      })
    }
  },

  watch: {
    stage_lists(){
      this.onSelectStage({ funnel: null })
    },
    funnel_mode(){
      this.stage_lists = []
      this.isLoading = true

      if(this.funnel_mode){
        this.tracker_version = 'v2'
      } else{
        this.tracker_version = 'v1'
      }

      this.getStages()
    }
  }
}
</script>
<style scope>
.save-t{
    color: #8c8c8c;
    font-size: 14px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #0078FA;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0078FA;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  border-radius: .25rem;
}

.slider.round:before {
  border-radius: .25rem;
}

.loading{
  width: 100%;
  box-sizing: border-box;
  padding: 50px 0;
  color: #0074F3;
  font-size: 20px;
  text-align: center;
}
</style>
